// The articles a startup chose to pursue out of publisher discovery, each prepared for contact and
// matched to the person it will be written to.
class BacklinkAcquisition {

  constructor(basePath, apiClient) {

    this.basePath = `${basePath}/search-visibility/backlink-opportunities`;
    this.outreachesPath = `${basePath}/search-visibility/backlink-outreaches`;
    this.retentionPath = `${basePath}/search-visibility/backlink-retention`;
    this.apiClient = apiClient;

  }

  async pursue(discoveryOpportunityIds) {

    const path = this.basePath;

    return this.apiClient.post(path, {}, {}, { discoveryOpportunityIds });

  }

  async getOpportunities(paginationOptions) {

    const path = this.basePath;

    return this.apiClient.get(path, {}, { paginationOptions });

  }

  // Sets a campaign up for these articles' recipients. Nothing is sent until the campaign goes live.
  async startOutreach(backlinkOpportunityIds) {

    const path = this.outreachesPath;

    return this.apiClient.post(path, {}, {}, { backlinkOpportunityIds });

  }

  async findContact(backlinkOpportunityId) {

    const path = `${this.basePath}/:backlinkOpportunityId/find-contact`;

    return this.apiClient.post(path, { backlinkOpportunityId }, {}, {});

  }

  async reviewContact(backlinkOpportunityId, decision) {

    const path = `${this.basePath}/:backlinkOpportunityId/contact-review`;

    return this.apiClient.post(path, { backlinkOpportunityId }, {}, { decision, reason: '' });

  }

  // Corrects what a recipient's reply was read as, for every article in that thread.
  async reviewReply(backlinkOpportunityId, messageId, intent) {

    const path = `${this.basePath}/:backlinkOpportunityId/reply-review`;

    return this.apiClient.post(path, { backlinkOpportunityId }, {}, { messageId, intent });

  }

  // Reads the article again for the link to the startup's page. The check runs in the background.
  async checkLink(backlinkOpportunityId) {

    const path = `${this.basePath}/:backlinkOpportunityId/link-check`;

    return this.apiClient.post(path, { backlinkOpportunityId }, {}, {});

  }

  // How many sites link to the startup's pages from an article: now, and kept 30 and 90 days.
  async getRetention() {

    const path = this.retentionPath;

    return this.apiClient.get(path, {}, {});

  }

}

export default BacklinkAcquisition;
